import { useSearchRegExps, useStatusCount } from "@quortex/front-common"
import { useMemo } from "react"
import type { L2VEndpointRow } from "@/App/play/App/Main/Pool/endpoints/l2VEndpoints/L2VEndpointList/helpers"
import type { OttEndpointRow } from "@/App/play/App/Main/Pool/endpoints/ottEndpoints/OttEndpointList/types"

export const weightedStatuses = ["warning", "configuring", "active", "down", "disabled"] as const
export const endpointMinorStatusList = ["configuring", "disabled"]
export const statusFilterOptionList = ["down", "warning", "configuring", "active", "disabled"]

export const useEndpointFilterListCount = (
  rowList: OttEndpointRow[] | L2VEndpointRow[],
  searchValue: string,
  searchFilterFn: (
    rowList: OttEndpointRow[] | L2VEndpointRow[],
    regexps: RegExp[]
  ) => OttEndpointRow[] | L2VEndpointRow[]
) => {
  const searchRegExps = useSearchRegExps(searchValue)

  const searchFilteredEndpointList = useMemo(
    () => searchFilterFn(rowList, searchRegExps),
    [searchRegExps, rowList, searchFilterFn]
  )

  const rowStatusCount = useStatusCount<OttEndpointRow | L2VEndpointRow>(searchFilteredEndpointList)

  return { rowStatusCount }
}

export interface EndpointComposition {
  customPath?: string
  input?: {
    identifier?: api.ott.Input["identifier"] | api.ott.InputV2["identifier"] | null
  } | null
  processing?: {
    identifier?: api.ott.Processing["identifier"]
  }
  target?: {
    identifier?: api.ott.Target["identifier"]
    type?: api.ott.Target["type"]
  }
  pretty?: string
}
